import axios from 'axios'
import library from '../../../utils/Library'

export const getSuborganizationTypeCorpEntities = async () => {
  const TOKEN = sessionStorage.getItem('token')
  const URL =
    library.getBaseAPIUrl('suborganizations') +
    '/getSuborganizationTypeCorpEntities'

  return await axios.get(URL, {
    headers: {
      Authorization: `Bearer ${TOKEN}`
    }
  })
}
